import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './authentication/AuthContext';
import { TablePreferencesProvider } from './Components/TableCustomizer';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.js";
// import "./fonts/araboto/Araboto Light 400.ttf";

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      {/* Inside AuthProvider so its axios interceptor is installed first — the
          preferences fetch then gets the same refresh-and-retry treatment as
          every other call. */}
      <TablePreferencesProvider>
        <App />
      </TablePreferencesProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
